/**
 * Created by aviab on 16/02/2017.
 */

const OMG_POST_ACTIONS = {
    SHOW_ME: 'ShowMe',
    CLOSE_ME: 'CloseMe',
    OPEN_REAL_GAME: '1',
    CASHIER: '6',
    QUICK_DEPOSIT: '7',
    MY_ACCOUNT: '21',
    SPORT: '24',
    EXTERNAL_LINK: '27',
    INTERNAL_URL: '32',
    OPEN_ANONYMOUS_GAME: '36',
    RICH: '56'
}

export {OMG_POST_ACTIONS};